import { render, staticRenderFns } from "./ResolveDataLink.vue?vue&type=template&id=ca582068"
import script from "./ResolveDataLink.vue?vue&type=script&lang=js"
export * from "./ResolveDataLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports